import React from 'react'
import EditEmailTemp from '../../../features/FiledManagement/EmailTemplateManagement/EditEmailTemp';
const EditEmailTemplate = () => {

    return (
        <div>
            <EditEmailTemp/>
        </div>
    )

}

export default EditEmailTemplate